import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';

import { APP_CONFIG, IAppConfig } from '@app/core/config';
import { UtilsService } from '@app/core/services';
import { UserBankAccountList, UserServiceAccountList } from '../models';



@Injectable({
	providedIn: 'root'
})
export class UserAccountService {

	constructor(
		@Inject(APP_CONFIG) private appConfig: IAppConfig,
		private httpClient: HttpClient,
		private utilsService: UtilsService
	) { }


	getBankAccounts(): Observable<UserBankAccountList[]> {
		return this.httpClient
			.get<UserBankAccountList[]>(`${this.appConfig.apiEndpoint}/new-core/bank-accounts/select?withPending=false`)
			.pipe(map(this.utilsService.handleResponse));
	}

	getBankAccountsByCurrency(currencyId: number, withPending: boolean = false): Observable<UserBankAccountList[]> {
		const url = `${this.appConfig.apiEndpoint}/new-core/bank-accounts/select?currencyId=${currencyId}&withPending=${withPending}`;

		return this.httpClient
			.get<UserBankAccountList[]>(url)
			.pipe(map(this.utilsService.handleResponse));
	}

	getServiceAccountsByService(serviceId: number): Observable<UserServiceAccountList[]> {
		const url = `${this.appConfig.apiEndpoint}/new-core/service-accounts/by-service/${serviceId}`;
		return this.httpClient
			.get<UserServiceAccountList[]>(url)
			.pipe(map(this.utilsService.handleResponse));
	}
}
